var Backbone, SupportCurrentOrderModel, SupportDealSummaryTemplate, SupportDealSummaryView, SupportMarketRateImagePresenterPresentation, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportMarketRateImagePresenterPresentation = require('../../presenters/market_rate_image_presenter');

SupportCurrentOrderModel = require('../../models/current_order');

SupportUtilsHelper = require('../../helpers/utils');

Backbone = require('backbone');

Backbone.$ = $;

SupportDealSummaryTemplate = require('../../../deal_summary.html.mustache');

SupportDealSummaryView = (function(superClass) {
  extend(SupportDealSummaryView, superClass);

  function SupportDealSummaryView() {
    return SupportDealSummaryView.__super__.constructor.apply(this, arguments);
  }

  SupportDealSummaryView.prototype.className = 'deal-summary';

  SupportDealSummaryView.prototype.initialize = function() {
    this.I18nScope = 'modules.support';
    this.template = SupportDealSummaryTemplate;
    this.order = Groupon.Support.currentOrder;
    this.orderPresenter = new SupportCurrentOrderModel;
    return this.dealData = this.toDealHash();
  };

  SupportDealSummaryView.prototype.events = {
    'click .v1-image': 'goToDealPage',
    'click .view_fine_print': 'showFinePrint'
  };

  SupportDealSummaryView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.dealData, this.I18nScope));
  };

  SupportDealSummaryView.prototype.goToDealPage = function() {
    var ref;
    if (((ref = this.order.deal) != null ? ref.dealUrl : void 0) != null) {
      return window.open(this.order.deal.dealUrl, "_blank");
    } else if (this.dealData.dealId != null) {
      return window.open("/deals/" + this.dealData.dealId, "_blank");
    }
  };

  SupportDealSummaryView.prototype.toDealHash = function() {
    return this.orderPresenter.toDealHash();
  };

  SupportDealSummaryView.prototype.showFinePrint = function() {
    return SupportUtilsHelper.renderFinePrint();
  };

  return SupportDealSummaryView;

})(Backbone.View);

module.exports = SupportDealSummaryView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9kZWFsX3N1bW1hcnlfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9vcmRlcl9yZWxhdGVkL2RlYWxfc3VtbWFyeV92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxJQUFBLHVKQUFBO0VBQUE7OztBQUFBLDJDQUFBLEdBQThDLE9BQUEsQ0FBUSw4Q0FBUjs7QUFDOUMsd0JBQUEsR0FBMkIsT0FBQSxDQUFRLDRCQUFSOztBQUMzQixrQkFBQSxHQUFxQixPQUFBLENBQVEscUJBQVI7O0FBQ3JCLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUNiLDBCQUFBLEdBQTZCLE9BQUEsQ0FBUSxxQ0FBUjs7QUFFdkI7Ozs7Ozs7bUNBQ0osU0FBQSxHQUFXOzttQ0FFWCxVQUFBLEdBQVksU0FBQTtJQUNWLElBQUMsQ0FBQSxTQUFELEdBQWE7SUFDYixJQUFDLENBQUEsUUFBRCxHQUFZO0lBQ1osSUFBQyxDQUFBLEtBQUQsR0FBUyxPQUFPLENBQUMsT0FBTyxDQUFDO0lBQ3pCLElBQUMsQ0FBQSxjQUFELEdBQWtCLElBQUk7V0FDdEIsSUFBQyxDQUFBLFFBQUQsR0FBWSxJQUFDLENBQUEsVUFBRCxDQUFBO0VBTEY7O21DQU9aLE1BQUEsR0FDRTtJQUFBLGlCQUFBLEVBQW1CLGNBQW5CO0lBQ0Esd0JBQUEsRUFBMEIsZUFEMUI7OzttQ0FHRixNQUFBLEdBQVEsU0FBQTtXQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsTUFBTCxDQUFZLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFDLENBQUEsUUFBbkIsRUFBNkIsSUFBQyxDQUFBLFNBQTlCLENBQVo7RUFETTs7bUNBR1IsWUFBQSxHQUFjLFNBQUE7QUFDWixRQUFBO0lBQUEsSUFBRyxnRUFBSDthQUNFLE1BQU0sQ0FBQyxJQUFQLENBQVksSUFBQyxDQUFBLEtBQUssQ0FBQyxJQUFJLENBQUMsT0FBeEIsRUFBaUMsUUFBakMsRUFERjtLQUFBLE1BRUssSUFBRyw0QkFBSDthQUNILE1BQU0sQ0FBQyxJQUFQLENBQVksU0FBQSxHQUFVLElBQUMsQ0FBQSxRQUFRLENBQUMsTUFBaEMsRUFBMEMsUUFBMUMsRUFERzs7RUFITzs7bUNBTWQsVUFBQSxHQUFZLFNBQUE7V0FDVixJQUFDLENBQUEsY0FBYyxDQUFDLFVBQWhCLENBQUE7RUFEVTs7bUNBR1osYUFBQSxHQUFlLFNBQUE7V0FDYixrQkFBa0IsQ0FBQyxlQUFuQixDQUFBO0VBRGE7Ozs7R0ExQm9CLFFBQVEsQ0FBQzs7QUE2QjlDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
